
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gkp463DZc_zz5bQMJFZphzaw7CUdM7GMfJuDP4JweT7MMeta } from "/codebuild/output/src2538904883/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexlqhkqYj0EAbtvJWTQ6Q2bz4bD61UfdiZtEGTADGOoOQMeta } from "/codebuild/output/src2538904883/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchHS2QzG0_HUoTATHW8px9X9qAaGkRCpxb2Hmwpg4IlQIMeta } from "/codebuild/output/src2538904883/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indextg4BKqAyfHq7hj0QW1vexVRpez_9qtLtHNN14zVHXZ4Meta } from "/codebuild/output/src2538904883/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93bc6fAYeq8ynHNo46dv1wc7Eyxtb2ZNE2DJ2QEGtID5YMeta } from "/codebuild/output/src2538904883/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index7wDhh3Nk1Ldo_45XNhOhzQTqx7wna9vWXf_45LNVts1o_TcMeta } from "/codebuild/output/src2538904883/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93_4551_45UZObwU8gUBpl7XLKmul1mPHlckSAMWi0rn_rm08Meta } from "/codebuild/output/src2538904883/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexwx4gcabaf8TxBPiUQU4jC99Ikp8MJpjJE8sogBipmREMeta } from "/codebuild/output/src2538904883/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93tfEbqfl_45O9YmSnCSp0M07ia00xWgD11147rj1tpcsp0Meta } from "/codebuild/output/src2538904883/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index2XRvnvbI0Nc6VScJ6RTyulG1jnD8UmRfBAUQPkGvbd8Meta } from "/codebuild/output/src2538904883/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexS01jAdYrrAZ8PLmcaEO30nfFeOSVd68Tx_yrzP1zP1QMeta } from "/codebuild/output/src2538904883/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2538904883/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2538904883/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2538904883/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2538904883/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2538904883/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index7wDhh3Nk1Ldo_45XNhOhzQTqx7wna9vWXf_45LNVts1o_TcMeta || {},
    component: () => import("/codebuild/output/src2538904883/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2538904883/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexwx4gcabaf8TxBPiUQU4jC99Ikp8MJpjJE8sogBipmREMeta || {},
    component: () => import("/codebuild/output/src2538904883/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2538904883/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index2XRvnvbI0Nc6VScJ6RTyulG1jnD8UmRfBAUQPkGvbd8Meta || {},
    component: () => import("/codebuild/output/src2538904883/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexS01jAdYrrAZ8PLmcaEO30nfFeOSVd68Tx_yrzP1zP1QMeta || {},
    component: () => import("/codebuild/output/src2538904883/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]